import { useRef as ut, useEffect as ct, useState as $t, Children as Dt } from "react";
import h from "dayjs";
function On(t, n) {
  const r = {
    ...t
  };
  return n.forEach((e) => {
    e in r && delete r[e];
  }), r;
}
function bt(t) {
  return ft(t) && "$y" in t && "$M" in t && "$D" in t && "$d" in t && "$H" in t && "$m" in t && "$s" in t;
}
function nt(t) {
  return Object.prototype.toString.call(t) === "[object Array]";
}
function ft(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function Mn(t) {
  return ft(t) && Object.keys(t).length === 0;
}
function Yn(t) {
  return Object.prototype.toString.call(t) === "[object Promise]";
}
function St(t) {
  return Object.prototype.toString.call(t) === "[object String]";
}
function Tt(t) {
  return Object.prototype.toString.call(t) === "[object Number]" && t === t;
}
function xn(t) {
  return Object.prototype.toString.call(t) === "[object File]";
}
function kt(t) {
  return typeof t == "function";
}
function C(t) {
  return t === void 0;
}
function $n(t) {
  return t === null;
}
function Dn(t) {
  return t == null;
}
const bn = function() {
  try {
    return !(typeof window < "u" && document !== void 0);
  } catch {
    return !0;
  }
}(), it = (t) => St(t) || Tt(t);
function At(t) {
  const n = ut();
  return ct(() => {
    n.current = t;
  }), n.current;
}
function Sn(t, n) {
  const { defaultValue: r, value: e } = n || {}, o = ut(!0), a = At(n == null ? void 0 : n.value), [i, s] = $t(C(e) ? C(r) ? t : r : e);
  return ct(() => {
    if (o.current) {
      o.current = !1;
      return;
    }
    e === void 0 && a !== e && s(e);
  }, [e]), [C(e) ? i : e, s, i];
}
const F = typeof window > "u" ? globalThis : window, jt = ["webkit", "ms", "moz", "o"];
let k = F.requestAnimationFrame, D = F.cancelAnimationFrame;
if ((!k || !D) && (jt.some((t) => (k = F[`${t}RequestAnimationFrame`], D = F[`${t}CancelAnimationFrame`] || F[`${t}CancelRequestAnimationFrame`], k && D)), !k || !D)) {
  let t = 0;
  k = function(n) {
    const r = Date.now(), e = Math.max(0, 16 - (r - t));
    return setTimeout(() => {
      n(), t = r + e;
    }, e);
  }, D = function(n) {
    clearTimeout(n);
  };
}
k = k.bind(F);
D = D.bind(F);
function Tn(t) {
  let n = null;
  const r = function(...e) {
    n && D(n), n = k(() => {
      t(...e), n = null;
    });
  };
  return r.cancel = () => {
    D(n), n = null;
  }, r;
}
const kn = {
  Enter: 13,
  Esc: 27,
  ArrowLeft: 37,
  ArrowUp: 38,
  ArrowRight: 39,
  ArrowDown: 40
}, W = (t) => (n) => Math.pow(n, t), z = (t) => (n) => 1 - Math.abs(Math.pow(n - 1, t)), U = (t) => (n) => n < 0.5 ? W(t)(n * 2) / 2 : z(t)(n * 2 - 1) / 2 + 0.5, It = (t) => t, Et = W(2), Lt = z(2), Ft = U(2), Pt = W(3), qt = z(3), Ct = U(3), Bt = W(4), Rt = z(4), Ht = U(4), Wt = W(5), zt = z(5), Gt = U(5), Nt = (t) => 1 + Math.sin(Math.PI / 2 * t - Math.PI / 2), Zt = (t) => Math.sin(Math.PI / 2 * t), Ut = (t) => (1 + Math.sin(Math.PI * t - Math.PI / 2)) / 2, rt = (t) => t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? (t -= 1.5 / 2.75, 7.5625 * t * t + 0.75) : t < 2.5 / 2.75 ? (t -= 2.25 / 2.75, 7.5625 * t * t + 0.9375) : (t -= 2.625 / 2.75, 7.5625 * t * t + 0.984375), dt = (t) => 1 - rt(1 - t), Xt = (t) => t < 0.5 ? dt(t * 2) * 0.5 : rt(t * 2 - 1) * 0.5 + 0.5, An = {
  linear: It,
  quadIn: Et,
  quadOut: Lt,
  quadInOut: Ft,
  cubicIn: Pt,
  cubicOut: qt,
  cubicInOut: Ct,
  quartIn: Bt,
  quartOut: Rt,
  quartInOut: Ht,
  quintIn: Wt,
  quintOut: zt,
  quintInOut: Gt,
  sineIn: Nt,
  sineOut: Zt,
  sineInOut: Ut,
  bounceIn: dt,
  bounceOut: rt,
  bounceInOut: Xt
};
var B = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function R(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var ht = { exports: {} };
(function(t, n) {
  (function(r, e) {
    t.exports = e();
  })(B, function() {
    var r = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, e = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, o = /\d\d/, a = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, s = {}, d = function(c) {
      return (c = +c) + (c > 68 ? 1900 : 2e3);
    }, u = function(c) {
      return function(f) {
        this[c] = +f;
      };
    }, p = [/[+-]\d\d:?(\d\d)?|Z/, function(c) {
      (this.zone || (this.zone = {})).offset = function(f) {
        if (!f || f === "Z")
          return 0;
        var l = f.match(/([+-]|\d\d)/g), m = 60 * l[1] + (+l[2] || 0);
        return m === 0 ? 0 : l[0] === "+" ? -m : m;
      }(c);
    }], g = function(c) {
      var f = s[c];
      return f && (f.indexOf ? f : f.s.concat(f.f));
    }, y = function(c, f) {
      var l, m = s.meridiem;
      if (m) {
        for (var M = 1; M <= 24; M += 1)
          if (c.indexOf(m(M, 0, f)) > -1) {
            l = M > 12;
            break;
          }
      } else
        l = c === (f ? "pm" : "PM");
      return l;
    }, A = { A: [i, function(c) {
      this.afternoon = y(c, !1);
    }], a: [i, function(c) {
      this.afternoon = y(c, !0);
    }], S: [/\d/, function(c) {
      this.milliseconds = 100 * +c;
    }], SS: [o, function(c) {
      this.milliseconds = 10 * +c;
    }], SSS: [/\d{3}/, function(c) {
      this.milliseconds = +c;
    }], s: [a, u("seconds")], ss: [a, u("seconds")], m: [a, u("minutes")], mm: [a, u("minutes")], H: [a, u("hours")], h: [a, u("hours")], HH: [a, u("hours")], hh: [a, u("hours")], D: [a, u("day")], DD: [o, u("day")], Do: [i, function(c) {
      var f = s.ordinal, l = c.match(/\d+/);
      if (this.day = l[0], f)
        for (var m = 1; m <= 31; m += 1)
          f(m).replace(/\[|\]/g, "") === c && (this.day = m);
    }], M: [a, u("month")], MM: [o, u("month")], MMM: [i, function(c) {
      var f = g("months"), l = (g("monthsShort") || f.map(function(m) {
        return m.slice(0, 3);
      })).indexOf(c) + 1;
      if (l < 1)
        throw new Error();
      this.month = l % 12 || l;
    }], MMMM: [i, function(c) {
      var f = g("months").indexOf(c) + 1;
      if (f < 1)
        throw new Error();
      this.month = f % 12 || f;
    }], Y: [/[+-]?\d+/, u("year")], YY: [o, function(c) {
      this.year = d(c);
    }], YYYY: [/\d{4}/, u("year")], Z: p, ZZ: p };
    function wt(c) {
      var f, l;
      f = c, l = s && s.formats;
      for (var m = (c = f.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(I, b, O) {
        var w = O && O.toUpperCase();
        return b || l[O] || r[O] || l[w].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(S, T, E) {
          return T || E.slice(1);
        });
      })).match(e), M = m.length, Y = 0; Y < M; Y += 1) {
        var H = m[Y], j = A[H], x = j && j[0], $ = j && j[1];
        m[Y] = $ ? { regex: x, parser: $ } : H.replace(/^\[|\]$/g, "");
      }
      return function(I) {
        for (var b = {}, O = 0, w = 0; O < M; O += 1) {
          var S = m[O];
          if (typeof S == "string")
            w += S.length;
          else {
            var T = S.regex, E = S.parser, G = I.slice(w), P = T.exec(G)[0];
            E.call(b, P), I = I.replace(P, "");
          }
        }
        return function(L) {
          var v = L.afternoon;
          if (v !== void 0) {
            var q = L.hours;
            v ? q < 12 && (L.hours += 12) : q === 12 && (L.hours = 0), delete L.afternoon;
          }
        }(b), b;
      };
    }
    return function(c, f, l) {
      l.p.customParseFormat = !0, c && c.parseTwoDigitYear && (d = c.parseTwoDigitYear);
      var m = f.prototype, M = m.parse;
      m.parse = function(Y) {
        var H = Y.date, j = Y.utc, x = Y.args;
        this.$u = j;
        var $ = x[1];
        if (typeof $ == "string") {
          var I = x[2] === !0, b = x[3] === !0, O = I || b, w = x[2];
          b && (w = x[2]), s = this.$locale(), !I && w && (s = l.Ls[w]), this.$d = function(G, P, L) {
            try {
              if (["x", "X"].indexOf(P) > -1)
                return new Date((P === "X" ? 1e3 : 1) * G);
              var v = wt(P)(G), q = v.year, N = v.month, vt = v.day, Ot = v.hours, Mt = v.minutes, Yt = v.seconds, xt = v.milliseconds, st = v.zone, X = /* @__PURE__ */ new Date(), _ = vt || (q || N ? 1 : X.getDate()), Q = q || X.getFullYear(), Z = 0;
              q && !N || (Z = N > 0 ? N - 1 : X.getMonth());
              var K = Ot || 0, J = Mt || 0, V = Yt || 0, tt = xt || 0;
              return st ? new Date(Date.UTC(Q, Z, _, K, J, V, tt + 60 * st.offset * 1e3)) : L ? new Date(Date.UTC(Q, Z, _, K, J, V, tt)) : new Date(Q, Z, _, K, J, V, tt);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }(H, $, j), this.init(), w && w !== !0 && (this.$L = this.locale(w).$L), O && H != this.format($) && (this.$d = /* @__PURE__ */ new Date("")), s = {};
        } else if ($ instanceof Array)
          for (var S = $.length, T = 1; T <= S; T += 1) {
            x[1] = $[T - 1];
            var E = l.apply(this, x);
            if (E.isValid()) {
              this.$d = E.$d, this.$L = E.$L, this.init();
              break;
            }
            T === S && (this.$d = /* @__PURE__ */ new Date(""));
          }
        else
          M.call(this, Y);
      };
    };
  });
})(ht);
var _t = ht.exports;
const Qt = /* @__PURE__ */ R(_t);
var lt = { exports: {} };
(function(t, n) {
  (function(r, e) {
    t.exports = e();
  })(B, function() {
    return function(r, e, o) {
      e.prototype.isBetween = function(a, i, s, d) {
        var u = o(a), p = o(i), g = (d = d || "()")[0] === "(", y = d[1] === ")";
        return (g ? this.isAfter(u, s) : !this.isBefore(u, s)) && (y ? this.isBefore(p, s) : !this.isAfter(p, s)) || (g ? this.isBefore(u, s) : !this.isAfter(u, s)) && (y ? this.isAfter(p, s) : !this.isBefore(p, s));
      };
    };
  });
})(lt);
var Kt = lt.exports;
const Jt = /* @__PURE__ */ R(Kt);
var mt = { exports: {} };
(function(t, n) {
  (function(r, e) {
    t.exports = e();
  })(B, function() {
    var r = "week", e = "year";
    return function(o, a, i) {
      var s = a.prototype;
      s.week = function(d) {
        if (d === void 0 && (d = null), d !== null)
          return this.add(7 * (d - this.week()), "day");
        var u = this.$locale().yearStart || 1;
        if (this.month() === 11 && this.date() > 25) {
          var p = i(this).startOf(e).add(1, e).date(u), g = i(this).endOf(r);
          if (p.isBefore(g))
            return 1;
        }
        var y = i(this).startOf(e).date(u).startOf(r).subtract(1, "millisecond"), A = this.diff(y, r, !0);
        return A < 0 ? i(this).startOf("week").week() : Math.ceil(A);
      }, s.weeks = function(d) {
        return d === void 0 && (d = null), this.week(d);
      };
    };
  });
})(mt);
var Vt = mt.exports;
const tn = /* @__PURE__ */ R(Vt);
var pt = { exports: {} };
(function(t, n) {
  (function(r, e) {
    t.exports = e();
  })(B, function() {
    return function(r, e) {
      var o = e.prototype, a = o.format;
      o.format = function(i) {
        var s = this, d = this.$locale();
        if (!this.isValid())
          return a.bind(this)(i);
        var u = this.$utils(), p = (i || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(g) {
          switch (g) {
            case "Q":
              return Math.ceil((s.$M + 1) / 3);
            case "Do":
              return d.ordinal(s.$D);
            case "gggg":
              return s.weekYear();
            case "GGGG":
              return s.isoWeekYear();
            case "wo":
              return d.ordinal(s.week(), "W");
            case "w":
            case "ww":
              return u.s(s.week(), g === "w" ? 1 : 2, "0");
            case "W":
            case "WW":
              return u.s(s.isoWeek(), g === "W" ? 1 : 2, "0");
            case "k":
            case "kk":
              return u.s(String(s.$H === 0 ? 24 : s.$H), g === "k" ? 1 : 2, "0");
            case "X":
              return Math.floor(s.$d.getTime() / 1e3);
            case "x":
              return s.$d.getTime();
            case "z":
              return "[" + s.offsetName() + "]";
            case "zzz":
              return "[" + s.offsetName("long") + "]";
            default:
              return g;
          }
        });
        return a.bind(this)(p);
      };
    };
  });
})(pt);
var nn = pt.exports;
const en = /* @__PURE__ */ R(nn);
var gt = { exports: {} };
(function(t, n) {
  (function(r, e) {
    t.exports = e();
  })(B, function() {
    return function(r, e) {
      e.prototype.weekYear = function() {
        var o = this.month(), a = this.week(), i = this.year();
        return a === 1 && o === 11 ? i + 1 : o === 0 && a >= 52 ? i - 1 : i;
      };
    };
  });
})(gt);
var rn = gt.exports;
const on = /* @__PURE__ */ R(rn);
var yt = { exports: {} };
(function(t, n) {
  (function(r, e) {
    t.exports = e();
  })(B, function() {
    var r = "month", e = "quarter";
    return function(o, a) {
      var i = a.prototype;
      i.quarter = function(u) {
        return this.$utils().u(u) ? Math.ceil((this.month() + 1) / 3) : this.month(this.month() % 3 + 3 * (u - 1));
      };
      var s = i.add;
      i.add = function(u, p) {
        return u = Number(u), this.$utils().p(p) === e ? this.add(3 * u, r) : s.bind(this)(u, p);
      };
      var d = i.startOf;
      i.startOf = function(u, p) {
        var g = this.$utils(), y = !!g.u(p) || p;
        if (g.p(u) === e) {
          var A = this.quarter() - 1;
          return y ? this.month(3 * A).startOf(r).startOf("day") : this.month(3 * A + 2).endOf(r).endOf("day");
        }
        return d.bind(this)(u, p);
      };
    };
  });
})(yt);
var sn = yt.exports;
const an = /* @__PURE__ */ R(sn);
h.extend(Jt);
h.extend(tn);
h.extend(en);
h.extend(on);
h.extend(an);
h.extend(Qt);
const jn = h;
function In(t, n, r, e) {
  if (!t)
    return;
  const o = (i) => {
    if (bt(i))
      return h(i.valueOf());
    if (typeof i == "string") {
      const s = h(i, n);
      return s.isValid() ? s : h(i, "YYYY-MM-DD");
    }
    return h(i);
  }, a = (i) => r !== void 0 || e ? ot(o(i), r, e) : o(i);
  return nt(t) ? t.map((i) => i ? a(i) : void 0) : a(t);
}
function En(t) {
  if (!t || !t[0] || !t[1])
    return t;
  const n = [...t];
  return n.sort((r, e) => r.valueOf() - e.valueOf()), n;
}
function Ln(t, n) {
  return n === void 0 && t === void 0 ? !1 : n && !t || !n && t || h(n).valueOf() !== h(t).valueOf();
}
function Fn(t, n) {
  return n === void 0 && t === void 0 ? !1 : n && !t || !n && t || nt(n) && nt(t) && h(n[0]).valueOf() !== h(t[0]).valueOf() || h(n == null ? void 0 : n[1]).valueOf() !== h(t == null ? void 0 : t[1]).valueOf();
}
function Pn(t, n) {
  return C(t) && !n ? h() : ot(h(), t, n);
}
const un = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
}, at = {}, cn = (t, n) => {
  const r = `${t}|${n || "short"}`;
  let e = at[r];
  return e || (e = new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: t,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  }), at[r] = e), e;
}, fn = (t, n) => {
  const r = new Date(t);
  return cn(n).formatToParts(r);
}, et = (t, n) => {
  const r = fn(t, n), e = [];
  for (let u = 0; u < r.length; u += 1) {
    const { type: p, value: g } = r[u], y = un[p];
    y >= 0 && (e[y] = parseInt(g, 10));
  }
  const o = e[3], a = o === 24 ? 0 : o, i = Date.UTC(e[0], e[1] - 1, e[2], a, e[4], e[5], 0);
  let s = +t;
  const d = s % 1e3;
  return s -= d, (i - s) / (60 * 1e3);
}, dn = (t, n, r) => {
  let e = t - n * 60 * 1e3;
  const o = et(e, r);
  if (n === o)
    return [e, n];
  e -= (o - n) * 60 * 1e3;
  const a = et(e, r);
  return o === a ? [e, o] : [t - Math.min(o, a) * 60 * 1e3, Math.max(o, a)];
};
function ot(t, n, r, e) {
  if (!t || C(n) && !r)
    return t;
  const o = -t.toDate().getTimezoneOffset(), a = C(n) ? r ? hn(t.valueOf(), r) : o : n, i = Math.abs(a) <= 16 ? a * 60 : a, s = e ? o - i : i - o;
  return h(h(t).valueOf() + s * 60 * 1e3);
}
function hn(t, n) {
  return dn(t, et((/* @__PURE__ */ new Date()).getTime(), n), n)[1];
}
function qn(t, n, r) {
  return ot(t, n, r, !0);
}
function Cn(t, n) {
  return typeof t == "string" && h(t, n).format(n) === t;
}
const Bn = (t, n, r, e) => r && e ? n(t, r) || n(t, e) || t.isBetween(r, e, null) : !1;
function Rn(t, n) {
  const r = t.year(), e = t.month(), o = t.date();
  if (n) {
    let a = n;
    return a = a.set("year", r), a = a.set("month", e), a = a.set("date", o), a;
  }
  return t;
}
function ln(t, n, r = " ") {
  const e = String(t);
  if (!n)
    return e;
  const o = e.length < n ? `${r}${e}` : e;
  return o.length < n ? ln(o, n, r) : o;
}
function mn(t) {
  const n = [""];
  return Dt.forEach(t, (r) => {
    const e = n.length - 1, o = n[e];
    it(r) && it(o) ? n[e] = `${o}${r}` : r && r.props && r.props.children && n.push(mn(r.props.children));
  }), n.join("");
}
const pn = (t) => t.scrollHeight > t.offsetHeight || t.scrollWidth > t.offsetWidth, Hn = (t, n = document.documentElement) => {
  const r = [];
  let e = t;
  for (; e && e !== n; )
    pn(e) && r.push(e), e = e.parentElement;
  return r;
};
function gn(t, n) {
  if (t != null) {
    if (kt(t)) {
      t(n);
      return;
    }
    try {
      t.current = n;
    } catch {
      throw new Error(`Cannot assign value '${n}' to ref '${t}'`);
    }
  }
}
function Wn(...t) {
  return (n) => {
    t.forEach((r) => gn(r, n));
  };
}
function zn(t, n, r = null) {
  if (!t || !n)
    return "";
  let e = t.style[n];
  try {
    if (document.defaultView) {
      const o = document.defaultView.getComputedStyle(t, r);
      return e || o[n] || "";
    }
  } catch {
    return e;
  }
  return "";
}
export {
  kn as KeyCode,
  D as caf,
  jn as dayjsPro,
  An as easingMethod,
  In as getDayjsValue,
  Pn as getNow,
  Hn as getScrollElements,
  En as getSortedDayjsArray,
  zn as getStyle,
  Rn as getValueWithTime,
  nt as isArray,
  bt as isDayjs,
  Fn as isDayjsArrayChange,
  Ln as isDayjsChange,
  Mn as isEmptyObject,
  xn as isFile,
  kt as isFunction,
  Bn as isInRange,
  $n as isNull,
  Dn as isNullOrUndefined,
  Tt as isNumber,
  ft as isObject,
  Yn as isPromise,
  pn as isScrollElement,
  bn as isServerRendering,
  it as isSingleNode,
  St as isString,
  C as isUndefined,
  Cn as isValidTimeString,
  Wn as mergeRefs,
  mn as mergedToString,
  On as omit,
  ln as padStart,
  k as raf,
  Tn as throttleByRaf,
  hn as timezoneToOffset,
  qn as toLocal,
  ot as toTimezone,
  Sn as useMergeValue,
  At as usePrevious
};
//# sourceMappingURL=index.js.map
